import { GlobalStyle, theme, useColorModeValue, useStyleConfig } from "@chakra-ui/react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Mint from "./pages/mint";




function App() {

  return (
    <>
      <Routes>
        <Route path="*" element={<Mint/>}/>
      </Routes>
    </>
  );
}

export default App;
